// ============================================================
// Pay Rocky - App Constants
// ============================================================

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://payrocky.onrender.com/api';
export const TELEGRAM_CHANNEL_URL = 'https://t.me/payrocky';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@payrocky.com';
export const KYC_DOCUMENT_TYPES = ['NIN'];

export const CRYPTO_LIST = [
  {
    id: 'btc',
    name: 'Bitcoin',
    symbol: 'BTC',
    networks: ['BTC'],
    color: '#f7931a',
  },
  {
    id: 'eth',
    name: 'Ethereum',
    symbol: 'ETH',
    networks: ['ERC20'],
    color: '#627eea',
  },
  {
    id: 'usdt',
    name: 'Tether',
    symbol: 'USDT',
    networks: ['TRC20', 'ERC20', 'BEP20'],
    color: '#26a17b',
  },
  {
    id: 'usdc',
    name: 'USD Coin',
    symbol: 'USDC',
    networks: ['ERC20', 'BEP20', 'BASE'],
    color: '#2775ca',
  },
  {
    id: 'trx',
    name: 'Tron',
    symbol: 'TRX',
    networks: ['TRC20'],
    color: '#ef0027',
  },
  {
    id: 'bnb',
    name: 'BNB Smart Chain',
    symbol: 'BNB',
    networks: ['BEP20'],
    color: '#f0b90b',
  },
  {
    id: 'sol',
    name: 'Solana',
    symbol: 'SOL',
    networks: ['SOL'],
    color: '#14f195',
  },
  {
    id: 'ltc',
    name: 'Litecoin',
    symbol: 'LTC',
    networks: ['LTC'],
    color: '#345d9d',
  },
  {
    id: 'ton',
    name: 'Ton',
    symbol: 'TON',
    networks: ['TON'],
    color: '#0098ea',
  },
  {
    id: 'baseeth',
    name: 'Base Eth',
    symbol: 'BASE ETH',
    networks: ['BASE'],
    color: '#0052ff',
  },
  {
    id: 'sui',
    name: 'Sui',
    symbol: 'SUI',
    networks: ['SUI'],
    color: '#6fbcf0',
  },
];

export const TRADABLE_CRYPTO_LIST = CRYPTO_LIST;
export const HOMEPAGE_RATE_COIN_IDS = ['btc', 'eth', 'usdt', 'usdc'];

export const DEFAULT_RATES = {
  btc: { buy: 97_480_000, sell: 95_200_000, usdPrice: 61_300, networkFees: { BTC: 3 } },
  eth: { buy: 5_024_100, sell: 4_890_600, usdPrice: 3_159, networkFees: { ERC20: 4 } },
  usdt: { buy: 1_620, sell: 1_570, usdPrice: 1, networkFees: { TRC20: 3, ERC20: 5, BEP20: 4 } },
  usdc: { buy: 1_620, sell: 1_570, usdPrice: 1, networkFees: { ERC20: 5, BEP20: 4, BASE: 3 } },
  trx: { buy: 190, sell: 180, usdPrice: 0.12, networkFees: { TRC20: 1 } },
  bnb: { buy: 920_000, sell: 880_000, usdPrice: 580, networkFees: { BEP20: 2 } },
  sol: { buy: 238_500, sell: 228_000, usdPrice: 150, networkFees: { SOL: 2 } },
  ltc: { buy: 151_050, sell: 144_690, usdPrice: 95, networkFees: { LTC: 1 } },
  ton: { buy: 7_632, sell: 7_155, usdPrice: 4.8, networkFees: { TON: 1 } },
  baseeth: { buy: 5_024_100, sell: 4_890_600, usdPrice: 3_159, networkFees: { BASE: 3 } },
  sui: { buy: 5_247, sell: 4_929, usdPrice: 3.3, networkFees: { SUI: 1 } },
};

export const DEFAULT_WALLETS = {
  btc: {
    BTC: 'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
  },
  eth: {
    ERC20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
  },
  usdt: {
    TRC20: 'TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7',
    ERC20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
    BEP20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
  },
  usdc: {
    ERC20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
    BEP20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
    BASE: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
  },
  trx: {
    TRC20: 'TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7',
  },
  bnb: {
    BEP20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
  },
  sol: {
    SOL: '9xQeWvG816bUx9EPfEZSe4PqP4H8b6nH2R4M7gc3KJvM',
  },
  ltc: {
    LTC: 'ltc1qg82u3t9j0n4n0gw8e3g5y5x2k3a4g4y3h0n8xw',
  },
  ton: {
    TON: 'UQCdJ9R4lM4x9L9m5V4uQ3GQ6xV5h2t4x2v8M2x1q3d4f5g6',
  },
  baseeth: {
    BASE: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
  },
  sui: {
    SUI: '0x6c8f4e45a1d86d0b8e1f8f1c7d4b3a2910fedcba9876543210fedcba98765432',
  },
};

export const DEFAULT_BANK_DETAILS = {
  bank_name: process.env.REACT_APP_BANK_NAME || '',
  account_name: process.env.REACT_APP_ACCOUNT_NAME || '',
  account_number: process.env.REACT_APP_ACCOUNT_NUMBER || '',
};

export const DEFAULT_HOMEPAGE_BANNER = {
  image_url: '',
  whatsapp_number: '',
  whatsapp_message: '',
};

export const ORDER_LIMITS = {
  buy: {
    default: { minUsd: 10, maxUsd: 2000 },
    byCrypto: {},
  },
  sell: {
    default: { minUsd: 1, maxUsd: null },
    byCrypto: {},
  },
};

export const USD_TO_NGN = 1590;
export const RATE_LOCK_SECONDS = 900;

export const ORDER_STATUS = {
  PENDING: { label: 'Pending', color: '#b87a28', bg: 'rgba(184, 122, 40, 0.12)' },
  PROCESSING: { label: 'Processing', color: '#7a4b35', bg: 'rgba(122, 75, 53, 0.1)' },
  COMPLETED: { label: 'Completed', color: '#8f3b2e', bg: 'rgba(143, 59, 46, 0.1)' },
  CANCELLED: { label: 'Cancelled', color: '#b03a30', bg: 'rgba(176, 58, 48, 0.1)' },
};

export const NIGERIAN_BANKS = [
  'Access Bank',
  'Citibank Nigeria',
  'Ecobank Nigeria',
  'Fidelity Bank',
  'First Bank of Nigeria',
  'First City Monument Bank',
  'Guaranty Trust Bank',
  'Heritage Bank',
  'Keystone Bank',
  'Polaris Bank',
  'Stanbic IBTC Bank',
  'Standard Chartered Bank',
  'Sterling Bank',
  'Union Bank of Nigeria',
  'United Bank for Africa',
  'Unity Bank',
  'Wema Bank',
  'Zenith Bank',
  'Kuda Bank',
  'Opay',
  'Palmpay',
];

export const MOCK_USERS = [];
export const MOCK_ORDERS = [];

export const FAQ_DATA = [
  {
    q: 'Why do I need to verify my identity on PayRocky?',
    a: 'Verification helps PayRocky protect users from fraud, payment disputes, and unauthorized transactions. It also helps us confirm that the person placing an order is the real account owner before sensitive crypto transfers are processed.',
  },
  {
    q: 'How long does a buy order take?',
    a: 'After uploading your proof of payment, our team verifies and releases crypto within 15-30 minutes during business hours.',
  },
  {
    q: 'Is there a minimum or maximum order?',
    a: 'Minimum order is N10,000 equivalent. Maximum per transaction is N5,000,000. Higher limits are available after enhanced KYC.',
  },
  {
    q: 'What networks do you support for stablecoins?',
    a: 'USDT is available on TRC20, ERC20, and BEP20. USDC is available on ERC20, BEP20, and Base. Lower-fee options usually depend on the network you choose.',
  },
  {
    q: 'How do I sell crypto on PayRocky?',
    a: 'Select Sell, enter your amount, provide your bank details, and we generate a deposit wallet. Once we receive your crypto on-chain, we send Naira to your account.',
  },
  {
    q: 'Are my funds safe?',
    a: 'All crypto is held in cold or warm wallets with manual operational review. No transaction is processed without PayRocky verification.',
  },
  {
    q: 'What if I send to the wrong address?',
    a: 'Blockchain transactions are irreversible. Always double-check the wallet address before sending. PayRocky is not liable for user-initiated send errors.',
  },
];
